<template>
    <div
        v-if="items && items.length"
        class="toggle-buttons"
    >
        <BaseButton
            class="toggle-buttons__button dn-button uro-button dn-button--small"
            :class="{ 'dn-button--faded' : modelValue }"
            value=""
            aria-label="Show all"
            @click="updateValue"
        >
            All
        </BaseButton>
        <BaseButton
            v-for="item in items"
            :key="item.slug"
            class="toggle-buttons__button dn-button uro-button dn-button--small"
            :class="{ 'dn-button--faded' : item.slug !== modelValue }"
            :value="item.slug"
            :aria-label="`Show ${item.title}`"
            @click="updateValue"
        >
            {{ item.title }}
        </BaseButton>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            required: false,
            default: ''
        },
        items: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    emits: ['update:modelValue'],

    methods: {
        updateValue(e) {
            this.$emit('update:modelValue', e.target.value !== '' ? e.target.value : undefined);
        }
    }
};
</script>

<style lang="less" src="./BaseToggleButtons.less" />
